module.exports = __webpack_public_path__ + "static/media/image-4.e00e20aa.jpg";